
import { Store } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PublicMenuHeaderProps {
  storeName: string | null;
  tableName: string | null;
  tableNumber: number | null;
}

export function PublicMenuHeader({
  storeName,
  tableName,
  tableNumber,
}: PublicMenuHeaderProps) {
  const { t } = useTranslation();
  
  return (
    <div className='text-center mb-8'>
      <Store className='h-10 w-10 mx-auto mb-2 text-primary opacity-80' />
      <h1 className='text-3xl font-bold'>{storeName || 'Menu'}</h1>
      {tableName && tableNumber && (
        <p className='text-muted-foreground'>
          Table {tableNumber}: {tableName}
        </p>
      )}
    </div>
  );
}
